import { AfterViewInit, Directive, ElementRef, inject, input, OnChanges } from '@angular/core';
import { MatTooltip } from '@angular/material/tooltip';

@Directive({
  selector: '[mdwTooltipIfClipped]',
  standalone: true,
})
export class MdwTooltipIfClipped implements AfterViewInit, OnChanges {
  private elementRef = inject<ElementRef<HTMLElement>>(ElementRef);
  public matTooltip = inject(MatTooltip, { self: true });

  public tooltip = input.required<string>();

  public ngAfterViewInit(): void {
    this.updateTooltip();
  }

  public ngOnChanges(): void {
    this.updateTooltip();
  }

  private updateTooltip() {
    const element = this.elementRef.nativeElement;
    setTimeout(() => {
      // Height catches multi-line clamps (line-clamp), width single-line ellipses.
      const isOverflowing =
        element.scrollWidth > element.clientWidth || element.scrollHeight > element.clientHeight;

      this.matTooltip.message = isOverflowing ? this.tooltip() : '';
    });
  }
}
